import React from 'react';
import { DropdownOption } from '../../utils/WorkOrder';
import styles from './DropDown.scss';
import { Dropdown } from 'design-system-web';
import { useTranslation } from 'react-i18next';

interface DropdownProps {
  DropdownOptions?: DropdownOption[];
  DropdownValue: string;
  setDropdownValue: (id: string) => void;
  disabled?: boolean;
  showLabel?: boolean;
  label?: string;
  labelClassName?: string;
  showAsterisk?: boolean;
  placeholder?: string;
}

export const DropdownSelection = ({
  DropdownOptions = [],
  DropdownValue,
  setDropdownValue,
  disabled = false,
  showLabel = false,
  label = '',
  labelClassName = '',
  showAsterisk = false,
  placeholder = '',
}: DropdownProps) => {
  const { t } = useTranslation();
  const asterisk = '*';

  return (
    <div className={styles.dropdownContainer}>
      {showLabel && (
        <div className={`${styles.label} ${labelClassName}`}>
          {label}{' '}
          {showAsterisk && (
            <span className={styles.requiredAsterisk}>{asterisk}</span>
          )}
        </div>
      )}
      <div className={styles.dropdown}>
        <Dropdown
          placeholder={t(placeholder)}
          value={DropdownValue}
          items={DropdownOptions.map(optionValue => ({
            label: optionValue.name,
            value: optionValue.id,
          }))}
          onValueChange={value => setDropdownValue(value)}
          name="dropdown"
          isFullWidth
          disabled={disabled}
          doTranslation={false}
        />
      </div>
    </div>
  );
};